import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Create, FileCopySharp } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsUpdate } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Periodo', accessor: 'Periodo', width: 100 },
  { Header: 'Zonal', accessor: 'zonal', width: 140 },
  { Header: 'Jefe de venta', accessor: 'boss_sale' },
  { Header: 'Tipo', accessor: 'type', width: 150 },
  { Header: 'Cuota', accessor: 'quota', excelEnabled: false },
  { Header: 'Cuota', accessor: 'quota_string', hidden: true },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];


export default WithApp(function QuotaWinterBossSale(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [cuotas, setCuotas] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  const handleChange = (id, field, value) => {
    const index = cuotas.findIndex((item) => item.id == id);
    cuotas[index][field] = value;
    setCuotas([...cuotas]);
  };

  async function loadCuotas(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/winter_quota_boss_supervisors', filter);
    setDataLoading(false);
    if (response.success) setCuotas(response.data);
  }

  async function updateCuota(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/winter_quota_boss_supervisors', id, { Periodo: valueSearch.Periodo, [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      loadCuotas(valueSearch);
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={() => loadCuotas(valueSearch)} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({ valueSearch })}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de cuotas por jefe de venta {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadCuotas}
              getValueSearch={(value) => setValueSearch(value)}
              date
              dateType="month"
              labelDate="Periodo"
              dateField="Periodo"
            />
            <ReactTable
              excelName="cuotas_supervisor"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={cuotas.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard
                        permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_DELETED}
                      >
                        <ButtonDelete
                          entity="sale/winter_quota_boss_supervisors"
                          id={item.id}
                          reload={() => {
                            setDataLoading(true);
                            loadCuotas(valueSearch).then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen({ ...item, valueSearch })}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                    </div>
                  ),
                  Periodo: item.Periodo,
                  zonal: item.zonal,
                  boss_sale: item.supervisor?.name,
                  type: item.type === 'I' ? 'Compra' : item.type === 'O' ? 'Venta' : item.type === 'C' ? 'Cobertura' : '',
                  quota_string: item.quota,
                  quota: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.quota}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="cuota"
                        margin="normal"
                        value={item.quota || ''}
                        onChange={(e) => handleChange(item.id, 'quota', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'quota', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
